<template>
  <v-card>
    <v-container>
      <v-row>
        <v-col cols="10">
          <v-card-title> Object Details</v-card-title>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
          <v-btn
            class="align-self-center"
            large
            icon
            color="primary"
            @click="$emit('close-dialog')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="5" class="d-flex justify-center">
          <div class="overflow-y-auto">
            <div v-for="item in detail_items" :key="item.idx">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title> {{ item.name }}: </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.value }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="7">
          <v-row>
            <v-col cols="12">
              <v-card tile>
                <v-tabs v-model="tab" grow>
                  <v-tab v-for="item in model_items" :key="item.idx">
                    {{ item.name }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item v-for="item in model_items" :key="item.idx">
                    <v-card tile>
                      <v-responsive :aspect-ratio="10 / 7.5">
                        <model-viewer
                          loading="eager"
                          reveal="interaction"
                          camera-controls
                          auto-rotate
                          :src="addrPrefix + '/' + item.obj"
                          :poster="addrPrefix + '/' + item.img"
                          alt="failed to load model"
                          style="width: 100%; height: 100%"
                        ></model-viewer>
                      </v-responsive>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-btn large color="primary" @click="$emit('second-retrieve', tab)">
                <v-icon left>mdi-cloud-search-outline</v-icon> Retrieve the
                Object!
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "ModelDetail",

  props: {
    addrPrefix: {
      type: String,
      requird: true,
    },
    detail_items: {
      type: Array,
      required: true,
    },
    model_items: {
      type: Array,
      required: true,
    },
    init_tab: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    tab: 0,
  }),

  watch: {
    init_tab: function (val) {
      this.tab = val;
    },
  },
};
</script>
